import * as swcHelpers from '@swc/helpers';
import { mapStoresResult } from '../../hooks/api/adapters/mapStoresResult.js';
import '../../types.js';
import '../../operations/queries/get-place-by-id.js';
import { GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY } from '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';

function getStores(apolloClient, _) {
    return _getStores.apply(this, arguments);
}
function _getStores() {
    _getStores = swcHelpers.asyncToGenerator(function*(apolloClient, { coordinates: { lat , lon  } , locale , maxResults =30 , forceDistance  }) {
        const variables = {
            searchGeoLocation: {
                lat,
                lon
            },
            maxResults,
            forceDistance
        };
        try {
            const { data , error  } = yield apolloClient.query({
                query: GET_STORES_BY_DISTANCE_WITHOUT_INVENTORY,
                variables,
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            });
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return mapStoresResult(data.storesByDistance);
        } catch (e) {
            console.error(`Failed to query stores: ${e}`);
            return [];
        }
    });
    return _getStores.apply(this, arguments);
}

export { getStores };
//# sourceMappingURL=data.js.map
